import React from 'react';

import {
  ServiceCard,
  ServiceSubCategoryCard,
} from '../../helpers/list-page/interfaces/list-card.interface';
import ImageWrapper from '../image-wrapper/Image-wrapper';
import Link from 'next/link';

interface CardServiceSubCategoryProps {
  card: ServiceSubCategoryCard;
  cardIndex: number;
}

export const CardServiceSubCategory = ({
  card,
  cardIndex,
}: CardServiceSubCategoryProps) => {
  return (
    <>
      <Link
        href={card?.slug}
        key={card?.id}
        className={`group flex cursor-pointer flex-col items-center justify-center rounded-xl bg-background-primary-light p-4 transition-opacity duration-200 ease-in-out lg:hover:bg-background-secondary focus:outline focus:outline-3 focus:outline-offset-3 focus:outline-text-light`}
      >
        {card?.imageWrapper?.jsonBynderAsset?.originalUrl && (
          <ImageWrapper
            url={card?.imageWrapper?.jsonBynderAsset?.originalUrl}
            alt={card?.imageWrapper?.altText || 'alt text not found'}
            imgClassName="h-16 w-16 object-contain"
            width={64}
            height={64}
          />
        )}
        <div className="w-full break-words text-center font-title text-headingxs text-text-light">
          {card?.name}
        </div>
      </Link>
    </>
  );
};
